import {PaymentMethodCategoryEnum} from "../payment-method-category.enum";
import {PaymentMethodCodesEnum} from "../payment-method-codes.enum";
import {PspCodesEnum} from "../psp-codes.enum";
import React from "react";
import {IPaymentMethodModel} from "../payment-method.model.interface";
import { CardNetworkModel } from "../card/networks/card-network.model";

export class NoPspPaymentMethod implements IPaymentMethodModel {

    readonly category: PaymentMethodCategoryEnum = PaymentMethodCategoryEnum.NoPSP;
    readonly code: PaymentMethodCodesEnum = PaymentMethodCodesEnum.NoPSP;
    readonly name: string = PaymentMethodCodesEnum.NoPSP;
    readonly pspCode: PspCodesEnum = PspCodesEnum.NoPSP;

    public static readonly instance = new NoPspPaymentMethod();

    async canMakePayments(): Promise<boolean> {
        return true;
    }

    getSortOrder(): number {
        return 0;
    }

    renderTabContent(): React.ReactElement {
        return (<></>);
    }

    renderTabHeader(): React.ReactElement {
        return (<></>);
    }

    renderPayButton(): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
        return (<></>);
    }
    update(pspCode: PspCodesEnum, supportedCardNetworks: CardNetworkModel[]): void {

    }

}